import {ref, onBeforeMount} from '@vue/composition-api'
import store from '@/store'


export default function useAppElementListAddNew(props={
    storeModuleName: "",
    addDataUrl: "",
    updateDataUrl: "",
    formModel: {},
    fieldOptions: {},
    reConstructFormModelOnUpdate: null
}) {


    const formModelCreate = ref(true)
    const formModel = ref({...props.formModel})
    const fieldOptions = ref({...props.fieldOptions})

    const reConstructFormModelOnUpdate = (initialObject, callback=props.reConstructFormModelOnUpdate) => {
        if (!callback) {
            for (const [key, value] of Object.entries(initialObject)) {
                if (key in formModel.value) {
                    formModel.value[key] = value
                }
            }
            return
        }
        formModel.value = callback(initialObject)
    }

    onBeforeMount(()=>{
        const item = store.state[props.storeModuleName] ? store.state[props.storeModuleName].elementInEdit : null
        if (item !== null) {
            formModelCreate.value = false
            reConstructFormModelOnUpdate(item)
            return
        }

        formModelCreate.value = true
        formModel.value = {...props.formModel}
    })

    const addData = (on_success=null, on_err=null, on_final=null) => {
        store
            .dispatch(props.addDataUrl, {
                data: formModel.value
            })
            .then((response) => on_success ? on_success(response.data) : null)
            .catch((err) => on_err ? on_err(err) : null)
            .finally((response) => on_final ? on_final(response) : null)
    };
    const updateData = (on_success=null, on_err=null, on_final=null) => {
        store
            .dispatch( props.updateDataUrl, {
                  id: store.state[props.storeModuleName].elementInEdit['uuid'],
                  params: formModel.value
            })
            .then((response) => on_success ? on_success(response.data) : null)
            .catch((err) => on_err ? on_err(err) : null)
            .finally((response) => on_final ? on_final(response) : null)
    };

    const submitAction = (options={}, callback=null)=>{

        store.commit(`${props.storeModuleName}/SET_IS_ADD_NEW_ELEMENT_BUSY`, true)

        const on_success = () => {
            store.commit(`${props.storeModuleName}/UPDATE_REFETCH_DATA`, true)
            store.commit(`${props.storeModuleName}/SET_IS_ADD_NEW_ELEMENT_COLLAPSED`, false)
        }
        const on_final = () => {
            store.commit(`${props.storeModuleName}/SET_IS_ADD_NEW_ELEMENT_BUSY`, false)
            callback ? callback() : null
        }

        if (formModelCreate.value === false) {
            updateData( on_success, null, on_final)
            return
        }
        addData( on_success, null, on_final)

    }

    const loading = ref(false)

    return {
        formModelCreate,
        formModel,
        fieldOptions,
        addData,
        updateData,
        submitAction,
        loading,
    }

}
